import React, { useState } from "react";
import { Navbar, Container, Nav, NavDropdown  } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "./nav.scss";

function Header() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Navbar bg="light" expand="lg" fixed="top" className="shadow py-2" expanded={expanded}>
      <Container>

        {/* Logo */}
        <Navbar.Brand as={NavLink} to="/" onClick={() => setExpanded(false)}>
          <img
            src="/images/uiplus_logo-bg.png"
            width="140"
            height="50"
            className="me-2"
            alt="Logo"
          />
          
        </Navbar.Brand>

        {/* Mobile Toggle Button */}
        <Navbar.Toggle aria-controls="basic-navbar-nav"
         onClick={() => setExpanded(!expanded)} />

        {/* Menu Items */}
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto custom-nav">

            <Nav.Link as={NavLink} to="/" end onClick={() => setExpanded(false)}>Home</Nav.Link>
            <Nav.Link as={NavLink} to="/about" onClick={() => setExpanded(false)}>About</Nav.Link>
            <Nav.Link as={NavLink} to="/service" onClick={() => setExpanded(false)}>Services</Nav.Link>

            
            <NavDropdown title="Products"  id="products-dropdown" >
    <NavDropdown.Item as={NavLink} to="/products/school-management" onClick={() => setExpanded(false)}>
      School ERP Software
    </NavDropdown.Item>

    <NavDropdown.Item as={NavLink} to="/products/finance-management" onClick={() => setExpanded(false)}>
      Finance Software
    </NavDropdown.Item>

    <NavDropdown.Item as={NavLink} to="/products/ecommerce-website" onClick={() => setExpanded(false)}>
      Ecommerce Website
    </NavDropdown.Item>

    <NavDropdown.Item as={NavLink} to="/products/website-management" onClick={() => setExpanded(false)}>
      Static / Dyanamic Website
    </NavDropdown.Item>

    <NavDropdown.Divider />

    <NavDropdown.Item as={NavLink} to="/products/custom-application" onClick={() => setExpanded(false)}>
      Custom Applications
    </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link as={NavLink} to="/careers" onClick={() => setExpanded(false)}>Careers</Nav.Link>
            <Nav.Link as={NavLink} to="/blogs" onClick={() => setExpanded(false)}>Blogs</Nav.Link>
            <Nav.Link as={NavLink} to="/contact" onClick={() => setExpanded(false)}>Contact</Nav.Link>

          </Nav>
       </Navbar.Collapse>

      </Container>
    </Navbar>
  );
}

export default Header;


